/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CustomersIndexRouteImport } from './routes/customers/index'
import { Route as CustomersIdRouteImport } from './routes/customers/$id'
import { Route as CustomersCreateRouteImport } from './routes/customers/create'
import { Route as DeveloperToolsGraphqlRouteImport } from './routes/developer-tools/graphql'
import { Route as DocsIndexRouteImport } from './routes/docs/index'
import { Route as DownloadsIndexRouteImport } from './routes/downloads/index'
import { Route as ProjectsIndexRouteImport } from './routes/projects/index'
import { Route as ProjectsIdentifierRouteImport } from './routes/projects/$identifier'
import { Route as ProjectsCreateRouteImport } from './routes/projects/create'
import { Route as TransactionsIndexRouteImport } from './routes/transactions/index'
import { Route as AdminClientsIndexRouteImport } from './routes/admin/clients/index'
import { Route as AdminClientsIdRouteImport } from './routes/admin/clients/$id'
import { Route as AdminClientsCreateRouteImport } from './routes/admin/clients/create'
import { Route as AdminNewsIndexRouteImport } from './routes/admin/news/index'
import { Route as AdminNewsIdRouteImport } from './routes/admin/news/$id'
import { Route as AdminNewsCreateRouteImport } from './routes/admin/news/create'
import { Route as AdminProductsIndexRouteImport } from './routes/admin/products/index'
import { Route as AdminSourcesIndexRouteImport } from './routes/admin/sources/index'
import { Route as DocsDataUsePermittedUseRouteImport } from './routes/docs/data-use/permitted-use'
import { Route as DocsDataUseTermsOfUseRouteImport } from './routes/docs/data-use/terms-of-use'
import { Route as DocsDataUseTraceabilityRouteImport } from './routes/docs/data-use/traceability'
import { Route as DocsDownloadsIndexRouteImport } from './routes/docs/downloads/index'
import { Route as DocsDownloadsUnderlyingDataRouteImport } from './routes/docs/downloads/underlying-data'
import { Route as DocsGettingStartedLoginRouteImport } from './routes/docs/getting-started/login'
import { Route as DocsGettingStartedProjectsRouteImport } from './routes/docs/getting-started/projects'
import { Route as DocsPlatformAccessRouteImport } from './routes/docs/platform/access'
import { Route as DocsPlatformDesignPrinciplesRouteImport } from './routes/docs/platform/design-principles'
import { Route as DocsPropertySearchIndexRouteImport } from './routes/docs/property-search/index'
import { Route as DocsPropertySearchCostsRouteImport } from './routes/docs/property-search/costs'
import { Route as DocsPropertySearchPreviousSearchesRouteImport } from './routes/docs/property-search/previous-searches'
import { Route as DocsPropertySearchPropertyInformationRouteImport } from './routes/docs/property-search/property-information'
import { Route as DocsPropertySearchSelectPropertiesRouteImport } from './routes/docs/property-search/select-properties'
import { Route as DocsPropertySearchSpecifyDataExtractRouteImport } from './routes/docs/property-search/specify-data-extract'
import { Route as FlowsAuthorizeExternalIndexRouteImport } from './routes/flows/authorize-external/index'
import { Route as FlowsAuthorizeExternalChooseProjectRouteImport } from './routes/flows/authorize-external/choose-project'
import { Route as FlowsAuthorizeIdentifierRouteImport } from './routes/flows/authorize/$identifier'
import { Route as FlowsDownloadChooseProjectRouteImport } from './routes/flows/download/choose-project'
import { Route as PropertySearchIndexRouteImport } from './routes/property/search/index'
import { Route as PropertySearchSessionRouteImport } from './routes/property/search/$session'
import { Route as FlowsAuthorizeExternalAuthorizeIdentifierRouteImport } from './routes/flows/authorize-external/authorize.$identifier'
import { Route as FlowsDownloadAuthorizeIdentifierRouteImport } from './routes/flows/download/authorize.$identifier'
import { Route as FlowsDownloadSelectionIdentifierRouteImport } from './routes/flows/download/selection.$identifier'
import { Route as FlowsDownloadWaitIdRouteImport } from './routes/flows/download/wait.$id'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomersIndexRoute = CustomersIndexRouteImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomersIdRoute = CustomersIdRouteImport.update({
  id: '/customers/$id',
  path: '/customers/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomersCreateRoute = CustomersCreateRouteImport.update({
  id: '/customers/create',
  path: '/customers/create',
  getParentRoute: () => rootRouteImport,
} as any)
const DeveloperToolsGraphqlRoute = DeveloperToolsGraphqlRouteImport.update({
  id: '/developer-tools/graphql',
  path: '/developer-tools/graphql',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/developer-tools/graphql.lazy').then((d) => d.Route),
)
const DocsIndexRoute = DocsIndexRouteImport.update({
  id: '/docs/',
  path: '/docs/',
  getParentRoute: () => rootRouteImport,
} as any)
const DownloadsIndexRoute = DownloadsIndexRouteImport.update({
  id: '/downloads/',
  path: '/downloads/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsIndexRoute = ProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsIdentifierRoute = ProjectsIdentifierRouteImport.update({
  id: '/projects/$identifier',
  path: '/projects/$identifier',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsCreateRoute = ProjectsCreateRouteImport.update({
  id: '/projects/create',
  path: '/projects/create',
  getParentRoute: () => rootRouteImport,
} as any)
const TransactionsIndexRoute = TransactionsIndexRouteImport.update({
  id: '/transactions/',
  path: '/transactions/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminClientsIndexRoute = AdminClientsIndexRouteImport.update({
  id: '/admin/clients/',
  path: '/admin/clients/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminClientsIdRoute = AdminClientsIdRouteImport.update({
  id: '/admin/clients/$id',
  path: '/admin/clients/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminClientsCreateRoute = AdminClientsCreateRouteImport.update({
  id: '/admin/clients/create',
  path: '/admin/clients/create',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminNewsIndexRoute = AdminNewsIndexRouteImport.update({
  id: '/admin/news/',
  path: '/admin/news/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminNewsIdRoute = AdminNewsIdRouteImport.update({
  id: '/admin/news/$id',
  path: '/admin/news/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminNewsCreateRoute = AdminNewsCreateRouteImport.update({
  id: '/admin/news/create',
  path: '/admin/news/create',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminProductsIndexRoute = AdminProductsIndexRouteImport.update({
  id: '/admin/products/',
  path: '/admin/products/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSourcesIndexRoute = AdminSourcesIndexRouteImport.update({
  id: '/admin/sources/',
  path: '/admin/sources/',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsDataUsePermittedUseRoute = DocsDataUsePermittedUseRouteImport.update({
  id: '/docs/data-use/permitted-use',
  path: '/docs/data-use/permitted-use',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsDataUseTermsOfUseRoute = DocsDataUseTermsOfUseRouteImport.update({
  id: '/docs/data-use/terms-of-use',
  path: '/docs/data-use/terms-of-use',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsDataUseTraceabilityRoute = DocsDataUseTraceabilityRouteImport.update({
  id: '/docs/data-use/traceability',
  path: '/docs/data-use/traceability',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsDownloadsIndexRoute = DocsDownloadsIndexRouteImport.update({
  id: '/docs/downloads/',
  path: '/docs/downloads/',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsDownloadsUnderlyingDataRoute =
  DocsDownloadsUnderlyingDataRouteImport.update({
    id: '/docs/downloads/underlying-data',
    path: '/docs/downloads/underlying-data',
    getParentRoute: () => rootRouteImport,
  } as any)
const DocsGettingStartedLoginRoute = DocsGettingStartedLoginRouteImport.update({
  id: '/docs/getting-started/login',
  path: '/docs/getting-started/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsGettingStartedProjectsRoute =
  DocsGettingStartedProjectsRouteImport.update({
    id: '/docs/getting-started/projects',
    path: '/docs/getting-started/projects',
    getParentRoute: () => rootRouteImport,
  } as any)
const DocsPlatformAccessRoute = DocsPlatformAccessRouteImport.update({
  id: '/docs/platform/access',
  path: '/docs/platform/access',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsPlatformDesignPrinciplesRoute =
  DocsPlatformDesignPrinciplesRouteImport.update({
    id: '/docs/platform/design-principles',
    path: '/docs/platform/design-principles',
    getParentRoute: () => rootRouteImport,
  } as any)
const DocsPropertySearchIndexRoute = DocsPropertySearchIndexRouteImport.update({
  id: '/docs/property-search/',
  path: '/docs/property-search/',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsPropertySearchCostsRoute = DocsPropertySearchCostsRouteImport.update({
  id: '/docs/property-search/costs',
  path: '/docs/property-search/costs',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsPropertySearchPreviousSearchesRoute =
  DocsPropertySearchPreviousSearchesRouteImport.update({
    id: '/docs/property-search/previous-searches',
    path: '/docs/property-search/previous-searches',
    getParentRoute: () => rootRouteImport,
  } as any)
const DocsPropertySearchPropertyInformationRoute =
  DocsPropertySearchPropertyInformationRouteImport.update({
    id: '/docs/property-search/property-information',
    path: '/docs/property-search/property-information',
    getParentRoute: () => rootRouteImport,
  } as any)
const DocsPropertySearchSelectPropertiesRoute =
  DocsPropertySearchSelectPropertiesRouteImport.update({
    id: '/docs/property-search/select-properties',
    path: '/docs/property-search/select-properties',
    getParentRoute: () => rootRouteImport,
  } as any)
const DocsPropertySearchSpecifyDataExtractRoute =
  DocsPropertySearchSpecifyDataExtractRouteImport.update({
    id: '/docs/property-search/specify-data-extract',
    path: '/docs/property-search/specify-data-extract',
    getParentRoute: () => rootRouteImport,
  } as any)
const FlowsAuthorizeExternalIndexRoute =
  FlowsAuthorizeExternalIndexRouteImport.update({
    id: '/flows/authorize-external/',
    path: '/flows/authorize-external/',
    getParentRoute: () => rootRouteImport,
  } as any)
const FlowsAuthorizeExternalChooseProjectRoute =
  FlowsAuthorizeExternalChooseProjectRouteImport.update({
    id: '/flows/authorize-external/choose-project',
    path: '/flows/authorize-external/choose-project',
    getParentRoute: () => rootRouteImport,
  } as any)
const FlowsAuthorizeIdentifierRoute =
  FlowsAuthorizeIdentifierRouteImport.update({
    id: '/flows/authorize/$identifier',
    path: '/flows/authorize/$identifier',
    getParentRoute: () => rootRouteImport,
  } as any)
const FlowsDownloadChooseProjectRoute =
  FlowsDownloadChooseProjectRouteImport.update({
    id: '/flows/download/choose-project',
    path: '/flows/download/choose-project',
    getParentRoute: () => rootRouteImport,
  } as any)
const PropertySearchIndexRoute = PropertySearchIndexRouteImport.update({
  id: '/property/search/',
  path: '/property/search/',
  getParentRoute: () => rootRouteImport,
} as any)
const PropertySearchSessionRoute = PropertySearchSessionRouteImport.update({
  id: '/property/search/$session',
  path: '/property/search/$session',
  getParentRoute: () => rootRouteImport,
} as any)
const FlowsAuthorizeExternalAuthorizeIdentifierRoute =
  FlowsAuthorizeExternalAuthorizeIdentifierRouteImport.update({
    id: '/flows/authorize-external/authorize/$identifier',
    path: '/flows/authorize-external/authorize/$identifier',
    getParentRoute: () => rootRouteImport,
  } as any)
const FlowsDownloadAuthorizeIdentifierRoute =
  FlowsDownloadAuthorizeIdentifierRouteImport.update({
    id: '/flows/download/authorize/$identifier',
    path: '/flows/download/authorize/$identifier',
    getParentRoute: () => rootRouteImport,
  } as any)
const FlowsDownloadSelectionIdentifierRoute =
  FlowsDownloadSelectionIdentifierRouteImport.update({
    id: '/flows/download/selection/$identifier',
    path: '/flows/download/selection/$identifier',
    getParentRoute: () => rootRouteImport,
  } as any)
const FlowsDownloadWaitIdRoute = FlowsDownloadWaitIdRouteImport.update({
  id: '/flows/download/wait/$id',
  path: '/flows/download/wait/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/customers/$id': typeof CustomersIdRoute
  '/customers/create': typeof CustomersCreateRoute
  '/developer-tools/graphql': typeof DeveloperToolsGraphqlRoute
  '/projects/$identifier': typeof ProjectsIdentifierRoute
  '/projects/create': typeof ProjectsCreateRoute
  '/customers/': typeof CustomersIndexRoute
  '/docs/': typeof DocsIndexRoute
  '/downloads/': typeof DownloadsIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/transactions/': typeof TransactionsIndexRoute
  '/admin/clients/$id': typeof AdminClientsIdRoute
  '/admin/clients/create': typeof AdminClientsCreateRoute
  '/admin/news/$id': typeof AdminNewsIdRoute
  '/admin/news/create': typeof AdminNewsCreateRoute
  '/docs/data-use/permitted-use': typeof DocsDataUsePermittedUseRoute
  '/docs/data-use/terms-of-use': typeof DocsDataUseTermsOfUseRoute
  '/docs/data-use/traceability': typeof DocsDataUseTraceabilityRoute
  '/docs/downloads/underlying-data': typeof DocsDownloadsUnderlyingDataRoute
  '/docs/getting-started/login': typeof DocsGettingStartedLoginRoute
  '/docs/getting-started/projects': typeof DocsGettingStartedProjectsRoute
  '/docs/platform/access': typeof DocsPlatformAccessRoute
  '/docs/platform/design-principles': typeof DocsPlatformDesignPrinciplesRoute
  '/docs/property-search/costs': typeof DocsPropertySearchCostsRoute
  '/docs/property-search/previous-searches': typeof DocsPropertySearchPreviousSearchesRoute
  '/docs/property-search/property-information': typeof DocsPropertySearchPropertyInformationRoute
  '/docs/property-search/select-properties': typeof DocsPropertySearchSelectPropertiesRoute
  '/docs/property-search/specify-data-extract': typeof DocsPropertySearchSpecifyDataExtractRoute
  '/flows/authorize-external/choose-project': typeof FlowsAuthorizeExternalChooseProjectRoute
  '/flows/authorize/$identifier': typeof FlowsAuthorizeIdentifierRoute
  '/flows/download/choose-project': typeof FlowsDownloadChooseProjectRoute
  '/property/search/$session': typeof PropertySearchSessionRoute
  '/admin/clients/': typeof AdminClientsIndexRoute
  '/admin/news/': typeof AdminNewsIndexRoute
  '/admin/products/': typeof AdminProductsIndexRoute
  '/admin/sources/': typeof AdminSourcesIndexRoute
  '/docs/downloads/': typeof DocsDownloadsIndexRoute
  '/docs/property-search/': typeof DocsPropertySearchIndexRoute
  '/flows/authorize-external/': typeof FlowsAuthorizeExternalIndexRoute
  '/property/search/': typeof PropertySearchIndexRoute
  '/flows/authorize-external/authorize/$identifier': typeof FlowsAuthorizeExternalAuthorizeIdentifierRoute
  '/flows/download/authorize/$identifier': typeof FlowsDownloadAuthorizeIdentifierRoute
  '/flows/download/selection/$identifier': typeof FlowsDownloadSelectionIdentifierRoute
  '/flows/download/wait/$id': typeof FlowsDownloadWaitIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/customers/$id': typeof CustomersIdRoute
  '/customers/create': typeof CustomersCreateRoute
  '/developer-tools/graphql': typeof DeveloperToolsGraphqlRoute
  '/projects/$identifier': typeof ProjectsIdentifierRoute
  '/projects/create': typeof ProjectsCreateRoute
  '/customers': typeof CustomersIndexRoute
  '/docs': typeof DocsIndexRoute
  '/downloads': typeof DownloadsIndexRoute
  '/projects': typeof ProjectsIndexRoute
  '/transactions': typeof TransactionsIndexRoute
  '/admin/clients/$id': typeof AdminClientsIdRoute
  '/admin/clients/create': typeof AdminClientsCreateRoute
  '/admin/news/$id': typeof AdminNewsIdRoute
  '/admin/news/create': typeof AdminNewsCreateRoute
  '/docs/data-use/permitted-use': typeof DocsDataUsePermittedUseRoute
  '/docs/data-use/terms-of-use': typeof DocsDataUseTermsOfUseRoute
  '/docs/data-use/traceability': typeof DocsDataUseTraceabilityRoute
  '/docs/downloads/underlying-data': typeof DocsDownloadsUnderlyingDataRoute
  '/docs/getting-started/login': typeof DocsGettingStartedLoginRoute
  '/docs/getting-started/projects': typeof DocsGettingStartedProjectsRoute
  '/docs/platform/access': typeof DocsPlatformAccessRoute
  '/docs/platform/design-principles': typeof DocsPlatformDesignPrinciplesRoute
  '/docs/property-search/costs': typeof DocsPropertySearchCostsRoute
  '/docs/property-search/previous-searches': typeof DocsPropertySearchPreviousSearchesRoute
  '/docs/property-search/property-information': typeof DocsPropertySearchPropertyInformationRoute
  '/docs/property-search/select-properties': typeof DocsPropertySearchSelectPropertiesRoute
  '/docs/property-search/specify-data-extract': typeof DocsPropertySearchSpecifyDataExtractRoute
  '/flows/authorize-external/choose-project': typeof FlowsAuthorizeExternalChooseProjectRoute
  '/flows/authorize/$identifier': typeof FlowsAuthorizeIdentifierRoute
  '/flows/download/choose-project': typeof FlowsDownloadChooseProjectRoute
  '/property/search/$session': typeof PropertySearchSessionRoute
  '/admin/clients': typeof AdminClientsIndexRoute
  '/admin/news': typeof AdminNewsIndexRoute
  '/admin/products': typeof AdminProductsIndexRoute
  '/admin/sources': typeof AdminSourcesIndexRoute
  '/docs/downloads': typeof DocsDownloadsIndexRoute
  '/docs/property-search': typeof DocsPropertySearchIndexRoute
  '/flows/authorize-external': typeof FlowsAuthorizeExternalIndexRoute
  '/property/search': typeof PropertySearchIndexRoute
  '/flows/authorize-external/authorize/$identifier': typeof FlowsAuthorizeExternalAuthorizeIdentifierRoute
  '/flows/download/authorize/$identifier': typeof FlowsDownloadAuthorizeIdentifierRoute
  '/flows/download/selection/$identifier': typeof FlowsDownloadSelectionIdentifierRoute
  '/flows/download/wait/$id': typeof FlowsDownloadWaitIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/customers/$id': typeof CustomersIdRoute
  '/customers/create': typeof CustomersCreateRoute
  '/developer-tools/graphql': typeof DeveloperToolsGraphqlRoute
  '/projects/$identifier': typeof ProjectsIdentifierRoute
  '/projects/create': typeof ProjectsCreateRoute
  '/customers/': typeof CustomersIndexRoute
  '/docs/': typeof DocsIndexRoute
  '/downloads/': typeof DownloadsIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/transactions/': typeof TransactionsIndexRoute
  '/admin/clients/$id': typeof AdminClientsIdRoute
  '/admin/clients/create': typeof AdminClientsCreateRoute
  '/admin/news/$id': typeof AdminNewsIdRoute
  '/admin/news/create': typeof AdminNewsCreateRoute
  '/docs/data-use/permitted-use': typeof DocsDataUsePermittedUseRoute
  '/docs/data-use/terms-of-use': typeof DocsDataUseTermsOfUseRoute
  '/docs/data-use/traceability': typeof DocsDataUseTraceabilityRoute
  '/docs/downloads/underlying-data': typeof DocsDownloadsUnderlyingDataRoute
  '/docs/getting-started/login': typeof DocsGettingStartedLoginRoute
  '/docs/getting-started/projects': typeof DocsGettingStartedProjectsRoute
  '/docs/platform/access': typeof DocsPlatformAccessRoute
  '/docs/platform/design-principles': typeof DocsPlatformDesignPrinciplesRoute
  '/docs/property-search/costs': typeof DocsPropertySearchCostsRoute
  '/docs/property-search/previous-searches': typeof DocsPropertySearchPreviousSearchesRoute
  '/docs/property-search/property-information': typeof DocsPropertySearchPropertyInformationRoute
  '/docs/property-search/select-properties': typeof DocsPropertySearchSelectPropertiesRoute
  '/docs/property-search/specify-data-extract': typeof DocsPropertySearchSpecifyDataExtractRoute
  '/flows/authorize-external/choose-project': typeof FlowsAuthorizeExternalChooseProjectRoute
  '/flows/authorize/$identifier': typeof FlowsAuthorizeIdentifierRoute
  '/flows/download/choose-project': typeof FlowsDownloadChooseProjectRoute
  '/property/search/$session': typeof PropertySearchSessionRoute
  '/admin/clients/': typeof AdminClientsIndexRoute
  '/admin/news/': typeof AdminNewsIndexRoute
  '/admin/products/': typeof AdminProductsIndexRoute
  '/admin/sources/': typeof AdminSourcesIndexRoute
  '/docs/downloads/': typeof DocsDownloadsIndexRoute
  '/docs/property-search/': typeof DocsPropertySearchIndexRoute
  '/flows/authorize-external/': typeof FlowsAuthorizeExternalIndexRoute
  '/property/search/': typeof PropertySearchIndexRoute
  '/flows/authorize-external/authorize/$identifier': typeof FlowsAuthorizeExternalAuthorizeIdentifierRoute
  '/flows/download/authorize/$identifier': typeof FlowsDownloadAuthorizeIdentifierRoute
  '/flows/download/selection/$identifier': typeof FlowsDownloadSelectionIdentifierRoute
  '/flows/download/wait/$id': typeof FlowsDownloadWaitIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/customers/$id'
    | '/customers/create'
    | '/developer-tools/graphql'
    | '/projects/$identifier'
    | '/projects/create'
    | '/customers/'
    | '/docs/'
    | '/downloads/'
    | '/projects/'
    | '/transactions/'
    | '/admin/clients/$id'
    | '/admin/clients/create'
    | '/admin/news/$id'
    | '/admin/news/create'
    | '/docs/data-use/permitted-use'
    | '/docs/data-use/terms-of-use'
    | '/docs/data-use/traceability'
    | '/docs/downloads/underlying-data'
    | '/docs/getting-started/login'
    | '/docs/getting-started/projects'
    | '/docs/platform/access'
    | '/docs/platform/design-principles'
    | '/docs/property-search/costs'
    | '/docs/property-search/previous-searches'
    | '/docs/property-search/property-information'
    | '/docs/property-search/select-properties'
    | '/docs/property-search/specify-data-extract'
    | '/flows/authorize-external/choose-project'
    | '/flows/authorize/$identifier'
    | '/flows/download/choose-project'
    | '/property/search/$session'
    | '/admin/clients/'
    | '/admin/news/'
    | '/admin/products/'
    | '/admin/sources/'
    | '/docs/downloads/'
    | '/docs/property-search/'
    | '/flows/authorize-external/'
    | '/property/search/'
    | '/flows/authorize-external/authorize/$identifier'
    | '/flows/download/authorize/$identifier'
    | '/flows/download/selection/$identifier'
    | '/flows/download/wait/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/customers/$id'
    | '/customers/create'
    | '/developer-tools/graphql'
    | '/projects/$identifier'
    | '/projects/create'
    | '/customers'
    | '/docs'
    | '/downloads'
    | '/projects'
    | '/transactions'
    | '/admin/clients/$id'
    | '/admin/clients/create'
    | '/admin/news/$id'
    | '/admin/news/create'
    | '/docs/data-use/permitted-use'
    | '/docs/data-use/terms-of-use'
    | '/docs/data-use/traceability'
    | '/docs/downloads/underlying-data'
    | '/docs/getting-started/login'
    | '/docs/getting-started/projects'
    | '/docs/platform/access'
    | '/docs/platform/design-principles'
    | '/docs/property-search/costs'
    | '/docs/property-search/previous-searches'
    | '/docs/property-search/property-information'
    | '/docs/property-search/select-properties'
    | '/docs/property-search/specify-data-extract'
    | '/flows/authorize-external/choose-project'
    | '/flows/authorize/$identifier'
    | '/flows/download/choose-project'
    | '/property/search/$session'
    | '/admin/clients'
    | '/admin/news'
    | '/admin/products'
    | '/admin/sources'
    | '/docs/downloads'
    | '/docs/property-search'
    | '/flows/authorize-external'
    | '/property/search'
    | '/flows/authorize-external/authorize/$identifier'
    | '/flows/download/authorize/$identifier'
    | '/flows/download/selection/$identifier'
    | '/flows/download/wait/$id'
  id:
    | '__root__'
    | '/'
    | '/customers/$id'
    | '/customers/create'
    | '/developer-tools/graphql'
    | '/projects/$identifier'
    | '/projects/create'
    | '/customers/'
    | '/docs/'
    | '/downloads/'
    | '/projects/'
    | '/transactions/'
    | '/admin/clients/$id'
    | '/admin/clients/create'
    | '/admin/news/$id'
    | '/admin/news/create'
    | '/docs/data-use/permitted-use'
    | '/docs/data-use/terms-of-use'
    | '/docs/data-use/traceability'
    | '/docs/downloads/underlying-data'
    | '/docs/getting-started/login'
    | '/docs/getting-started/projects'
    | '/docs/platform/access'
    | '/docs/platform/design-principles'
    | '/docs/property-search/costs'
    | '/docs/property-search/previous-searches'
    | '/docs/property-search/property-information'
    | '/docs/property-search/select-properties'
    | '/docs/property-search/specify-data-extract'
    | '/flows/authorize-external/choose-project'
    | '/flows/authorize/$identifier'
    | '/flows/download/choose-project'
    | '/property/search/$session'
    | '/admin/clients/'
    | '/admin/news/'
    | '/admin/products/'
    | '/admin/sources/'
    | '/docs/downloads/'
    | '/docs/property-search/'
    | '/flows/authorize-external/'
    | '/property/search/'
    | '/flows/authorize-external/authorize/$identifier'
    | '/flows/download/authorize/$identifier'
    | '/flows/download/selection/$identifier'
    | '/flows/download/wait/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CustomersIdRoute: typeof CustomersIdRoute
  CustomersCreateRoute: typeof CustomersCreateRoute
  DeveloperToolsGraphqlRoute: typeof DeveloperToolsGraphqlRoute
  ProjectsIdentifierRoute: typeof ProjectsIdentifierRoute
  ProjectsCreateRoute: typeof ProjectsCreateRoute
  CustomersIndexRoute: typeof CustomersIndexRoute
  DocsIndexRoute: typeof DocsIndexRoute
  DownloadsIndexRoute: typeof DownloadsIndexRoute
  ProjectsIndexRoute: typeof ProjectsIndexRoute
  TransactionsIndexRoute: typeof TransactionsIndexRoute
  AdminClientsIdRoute: typeof AdminClientsIdRoute
  AdminClientsCreateRoute: typeof AdminClientsCreateRoute
  AdminNewsIdRoute: typeof AdminNewsIdRoute
  AdminNewsCreateRoute: typeof AdminNewsCreateRoute
  DocsDataUsePermittedUseRoute: typeof DocsDataUsePermittedUseRoute
  DocsDataUseTermsOfUseRoute: typeof DocsDataUseTermsOfUseRoute
  DocsDataUseTraceabilityRoute: typeof DocsDataUseTraceabilityRoute
  DocsDownloadsUnderlyingDataRoute: typeof DocsDownloadsUnderlyingDataRoute
  DocsGettingStartedLoginRoute: typeof DocsGettingStartedLoginRoute
  DocsGettingStartedProjectsRoute: typeof DocsGettingStartedProjectsRoute
  DocsPlatformAccessRoute: typeof DocsPlatformAccessRoute
  DocsPlatformDesignPrinciplesRoute: typeof DocsPlatformDesignPrinciplesRoute
  DocsPropertySearchCostsRoute: typeof DocsPropertySearchCostsRoute
  DocsPropertySearchPreviousSearchesRoute: typeof DocsPropertySearchPreviousSearchesRoute
  DocsPropertySearchPropertyInformationRoute: typeof DocsPropertySearchPropertyInformationRoute
  DocsPropertySearchSelectPropertiesRoute: typeof DocsPropertySearchSelectPropertiesRoute
  DocsPropertySearchSpecifyDataExtractRoute: typeof DocsPropertySearchSpecifyDataExtractRoute
  FlowsAuthorizeExternalChooseProjectRoute: typeof FlowsAuthorizeExternalChooseProjectRoute
  FlowsAuthorizeIdentifierRoute: typeof FlowsAuthorizeIdentifierRoute
  FlowsDownloadChooseProjectRoute: typeof FlowsDownloadChooseProjectRoute
  PropertySearchSessionRoute: typeof PropertySearchSessionRoute
  AdminClientsIndexRoute: typeof AdminClientsIndexRoute
  AdminNewsIndexRoute: typeof AdminNewsIndexRoute
  AdminProductsIndexRoute: typeof AdminProductsIndexRoute
  AdminSourcesIndexRoute: typeof AdminSourcesIndexRoute
  DocsDownloadsIndexRoute: typeof DocsDownloadsIndexRoute
  DocsPropertySearchIndexRoute: typeof DocsPropertySearchIndexRoute
  FlowsAuthorizeExternalIndexRoute: typeof FlowsAuthorizeExternalIndexRoute
  PropertySearchIndexRoute: typeof PropertySearchIndexRoute
  FlowsAuthorizeExternalAuthorizeIdentifierRoute: typeof FlowsAuthorizeExternalAuthorizeIdentifierRoute
  FlowsDownloadAuthorizeIdentifierRoute: typeof FlowsDownloadAuthorizeIdentifierRoute
  FlowsDownloadSelectionIdentifierRoute: typeof FlowsDownloadSelectionIdentifierRoute
  FlowsDownloadWaitIdRoute: typeof FlowsDownloadWaitIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers/': {
      id: '/customers/'
      path: '/customers'
      fullPath: '/customers/'
      preLoaderRoute: typeof CustomersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers/$id': {
      id: '/customers/$id'
      path: '/customers/$id'
      fullPath: '/customers/$id'
      preLoaderRoute: typeof CustomersIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers/create': {
      id: '/customers/create'
      path: '/customers/create'
      fullPath: '/customers/create'
      preLoaderRoute: typeof CustomersCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/developer-tools/graphql': {
      id: '/developer-tools/graphql'
      path: '/developer-tools/graphql'
      fullPath: '/developer-tools/graphql'
      preLoaderRoute: typeof DeveloperToolsGraphqlRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs/': {
      id: '/docs/'
      path: '/docs'
      fullPath: '/docs/'
      preLoaderRoute: typeof DocsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/downloads/': {
      id: '/downloads/'
      path: '/downloads'
      fullPath: '/downloads/'
      preLoaderRoute: typeof DownloadsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/': {
      id: '/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof ProjectsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$identifier': {
      id: '/projects/$identifier'
      path: '/projects/$identifier'
      fullPath: '/projects/$identifier'
      preLoaderRoute: typeof ProjectsIdentifierRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/create': {
      id: '/projects/create'
      path: '/projects/create'
      fullPath: '/projects/create'
      preLoaderRoute: typeof ProjectsCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/transactions/': {
      id: '/transactions/'
      path: '/transactions'
      fullPath: '/transactions/'
      preLoaderRoute: typeof TransactionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/clients/': {
      id: '/admin/clients/'
      path: '/admin/clients'
      fullPath: '/admin/clients/'
      preLoaderRoute: typeof AdminClientsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/clients/$id': {
      id: '/admin/clients/$id'
      path: '/admin/clients/$id'
      fullPath: '/admin/clients/$id'
      preLoaderRoute: typeof AdminClientsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/clients/create': {
      id: '/admin/clients/create'
      path: '/admin/clients/create'
      fullPath: '/admin/clients/create'
      preLoaderRoute: typeof AdminClientsCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/news/': {
      id: '/admin/news/'
      path: '/admin/news'
      fullPath: '/admin/news/'
      preLoaderRoute: typeof AdminNewsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/news/$id': {
      id: '/admin/news/$id'
      path: '/admin/news/$id'
      fullPath: '/admin/news/$id'
      preLoaderRoute: typeof AdminNewsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/news/create': {
      id: '/admin/news/create'
      path: '/admin/news/create'
      fullPath: '/admin/news/create'
      preLoaderRoute: typeof AdminNewsCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/products/': {
      id: '/admin/products/'
      path: '/admin/products'
      fullPath: '/admin/products/'
      preLoaderRoute: typeof AdminProductsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/sources/': {
      id: '/admin/sources/'
      path: '/admin/sources'
      fullPath: '/admin/sources/'
      preLoaderRoute: typeof AdminSourcesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs/data-use/permitted-use': {
      id: '/docs/data-use/permitted-use'
      path: '/docs/data-use/permitted-use'
      fullPath: '/docs/data-use/permitted-use'
      preLoaderRoute: typeof DocsDataUsePermittedUseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs/data-use/terms-of-use': {
      id: '/docs/data-use/terms-of-use'
      path: '/docs/data-use/terms-of-use'
      fullPath: '/docs/data-use/terms-of-use'
      preLoaderRoute: typeof DocsDataUseTermsOfUseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs/data-use/traceability': {
      id: '/docs/data-use/traceability'
      path: '/docs/data-use/traceability'
      fullPath: '/docs/data-use/traceability'
      preLoaderRoute: typeof DocsDataUseTraceabilityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs/downloads/': {
      id: '/docs/downloads/'
      path: '/docs/downloads'
      fullPath: '/docs/downloads/'
      preLoaderRoute: typeof DocsDownloadsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs/downloads/underlying-data': {
      id: '/docs/downloads/underlying-data'
      path: '/docs/downloads/underlying-data'
      fullPath: '/docs/downloads/underlying-data'
      preLoaderRoute: typeof DocsDownloadsUnderlyingDataRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs/getting-started/login': {
      id: '/docs/getting-started/login'
      path: '/docs/getting-started/login'
      fullPath: '/docs/getting-started/login'
      preLoaderRoute: typeof DocsGettingStartedLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs/getting-started/projects': {
      id: '/docs/getting-started/projects'
      path: '/docs/getting-started/projects'
      fullPath: '/docs/getting-started/projects'
      preLoaderRoute: typeof DocsGettingStartedProjectsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs/platform/access': {
      id: '/docs/platform/access'
      path: '/docs/platform/access'
      fullPath: '/docs/platform/access'
      preLoaderRoute: typeof DocsPlatformAccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs/platform/design-principles': {
      id: '/docs/platform/design-principles'
      path: '/docs/platform/design-principles'
      fullPath: '/docs/platform/design-principles'
      preLoaderRoute: typeof DocsPlatformDesignPrinciplesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs/property-search/': {
      id: '/docs/property-search/'
      path: '/docs/property-search'
      fullPath: '/docs/property-search/'
      preLoaderRoute: typeof DocsPropertySearchIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs/property-search/costs': {
      id: '/docs/property-search/costs'
      path: '/docs/property-search/costs'
      fullPath: '/docs/property-search/costs'
      preLoaderRoute: typeof DocsPropertySearchCostsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs/property-search/previous-searches': {
      id: '/docs/property-search/previous-searches'
      path: '/docs/property-search/previous-searches'
      fullPath: '/docs/property-search/previous-searches'
      preLoaderRoute: typeof DocsPropertySearchPreviousSearchesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs/property-search/property-information': {
      id: '/docs/property-search/property-information'
      path: '/docs/property-search/property-information'
      fullPath: '/docs/property-search/property-information'
      preLoaderRoute: typeof DocsPropertySearchPropertyInformationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs/property-search/select-properties': {
      id: '/docs/property-search/select-properties'
      path: '/docs/property-search/select-properties'
      fullPath: '/docs/property-search/select-properties'
      preLoaderRoute: typeof DocsPropertySearchSelectPropertiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs/property-search/specify-data-extract': {
      id: '/docs/property-search/specify-data-extract'
      path: '/docs/property-search/specify-data-extract'
      fullPath: '/docs/property-search/specify-data-extract'
      preLoaderRoute: typeof DocsPropertySearchSpecifyDataExtractRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/flows/authorize-external/': {
      id: '/flows/authorize-external/'
      path: '/flows/authorize-external'
      fullPath: '/flows/authorize-external/'
      preLoaderRoute: typeof FlowsAuthorizeExternalIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/flows/authorize-external/choose-project': {
      id: '/flows/authorize-external/choose-project'
      path: '/flows/authorize-external/choose-project'
      fullPath: '/flows/authorize-external/choose-project'
      preLoaderRoute: typeof FlowsAuthorizeExternalChooseProjectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/flows/authorize/$identifier': {
      id: '/flows/authorize/$identifier'
      path: '/flows/authorize/$identifier'
      fullPath: '/flows/authorize/$identifier'
      preLoaderRoute: typeof FlowsAuthorizeIdentifierRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/flows/download/choose-project': {
      id: '/flows/download/choose-project'
      path: '/flows/download/choose-project'
      fullPath: '/flows/download/choose-project'
      preLoaderRoute: typeof FlowsDownloadChooseProjectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/property/search/': {
      id: '/property/search/'
      path: '/property/search'
      fullPath: '/property/search/'
      preLoaderRoute: typeof PropertySearchIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/property/search/$session': {
      id: '/property/search/$session'
      path: '/property/search/$session'
      fullPath: '/property/search/$session'
      preLoaderRoute: typeof PropertySearchSessionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/flows/authorize-external/authorize/$identifier': {
      id: '/flows/authorize-external/authorize/$identifier'
      path: '/flows/authorize-external/authorize/$identifier'
      fullPath: '/flows/authorize-external/authorize/$identifier'
      preLoaderRoute: typeof FlowsAuthorizeExternalAuthorizeIdentifierRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/flows/download/authorize/$identifier': {
      id: '/flows/download/authorize/$identifier'
      path: '/flows/download/authorize/$identifier'
      fullPath: '/flows/download/authorize/$identifier'
      preLoaderRoute: typeof FlowsDownloadAuthorizeIdentifierRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/flows/download/selection/$identifier': {
      id: '/flows/download/selection/$identifier'
      path: '/flows/download/selection/$identifier'
      fullPath: '/flows/download/selection/$identifier'
      preLoaderRoute: typeof FlowsDownloadSelectionIdentifierRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/flows/download/wait/$id': {
      id: '/flows/download/wait/$id'
      path: '/flows/download/wait/$id'
      fullPath: '/flows/download/wait/$id'
      preLoaderRoute: typeof FlowsDownloadWaitIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CustomersIdRoute: CustomersIdRoute,
  CustomersCreateRoute: CustomersCreateRoute,
  DeveloperToolsGraphqlRoute: DeveloperToolsGraphqlRoute,
  ProjectsIdentifierRoute: ProjectsIdentifierRoute,
  ProjectsCreateRoute: ProjectsCreateRoute,
  CustomersIndexRoute: CustomersIndexRoute,
  DocsIndexRoute: DocsIndexRoute,
  DownloadsIndexRoute: DownloadsIndexRoute,
  ProjectsIndexRoute: ProjectsIndexRoute,
  TransactionsIndexRoute: TransactionsIndexRoute,
  AdminClientsIdRoute: AdminClientsIdRoute,
  AdminClientsCreateRoute: AdminClientsCreateRoute,
  AdminNewsIdRoute: AdminNewsIdRoute,
  AdminNewsCreateRoute: AdminNewsCreateRoute,
  DocsDataUsePermittedUseRoute: DocsDataUsePermittedUseRoute,
  DocsDataUseTermsOfUseRoute: DocsDataUseTermsOfUseRoute,
  DocsDataUseTraceabilityRoute: DocsDataUseTraceabilityRoute,
  DocsDownloadsUnderlyingDataRoute: DocsDownloadsUnderlyingDataRoute,
  DocsGettingStartedLoginRoute: DocsGettingStartedLoginRoute,
  DocsGettingStartedProjectsRoute: DocsGettingStartedProjectsRoute,
  DocsPlatformAccessRoute: DocsPlatformAccessRoute,
  DocsPlatformDesignPrinciplesRoute: DocsPlatformDesignPrinciplesRoute,
  DocsPropertySearchCostsRoute: DocsPropertySearchCostsRoute,
  DocsPropertySearchPreviousSearchesRoute:
    DocsPropertySearchPreviousSearchesRoute,
  DocsPropertySearchPropertyInformationRoute:
    DocsPropertySearchPropertyInformationRoute,
  DocsPropertySearchSelectPropertiesRoute:
    DocsPropertySearchSelectPropertiesRoute,
  DocsPropertySearchSpecifyDataExtractRoute:
    DocsPropertySearchSpecifyDataExtractRoute,
  FlowsAuthorizeExternalChooseProjectRoute:
    FlowsAuthorizeExternalChooseProjectRoute,
  FlowsAuthorizeIdentifierRoute: FlowsAuthorizeIdentifierRoute,
  FlowsDownloadChooseProjectRoute: FlowsDownloadChooseProjectRoute,
  PropertySearchSessionRoute: PropertySearchSessionRoute,
  AdminClientsIndexRoute: AdminClientsIndexRoute,
  AdminNewsIndexRoute: AdminNewsIndexRoute,
  AdminProductsIndexRoute: AdminProductsIndexRoute,
  AdminSourcesIndexRoute: AdminSourcesIndexRoute,
  DocsDownloadsIndexRoute: DocsDownloadsIndexRoute,
  DocsPropertySearchIndexRoute: DocsPropertySearchIndexRoute,
  FlowsAuthorizeExternalIndexRoute: FlowsAuthorizeExternalIndexRoute,
  PropertySearchIndexRoute: PropertySearchIndexRoute,
  FlowsAuthorizeExternalAuthorizeIdentifierRoute:
    FlowsAuthorizeExternalAuthorizeIdentifierRoute,
  FlowsDownloadAuthorizeIdentifierRoute: FlowsDownloadAuthorizeIdentifierRoute,
  FlowsDownloadSelectionIdentifierRoute: FlowsDownloadSelectionIdentifierRoute,
  FlowsDownloadWaitIdRoute: FlowsDownloadWaitIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
